import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1235.1411,1439.9223 L1044.8241,1439.9223 L864.8271,1259.9243 L1499.9761,624.7753 L1775.1321,899.9303 L1235.1411,1439.9223 Z M1902.4501,857.4503 L1542.4561,497.4563 C1518.9351,474.0573 1481.0161,474.0573 1457.6171,497.4563 L737.6281,1217.4453 C714.1091,1240.9653 714.1091,1278.8843 737.6281,1302.4033 L875.1461,1439.9223 L0.0001,1439.9223 L0.0001,1559.9203 L1259.9801,1559.9203 C1275.9401,1559.9203 1291.1801,1553.5603 1302.4601,1542.4003 L1902.4501,942.4093 C1925.8491,918.8903 1925.8491,880.9703 1902.4501,857.4503 L1902.4501,857.4503 Z",
  transform: "translate(0 180)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.0339 0.004L120.0339 120.003 615.0269 120.003 243.3919 1180.066 356.5499 1219.786 742.1049 120.003 1200.0169 120.003 1200.0169 0.004z",
  transform: "translate(0 180)"
}));

var IconClearTextFormattingLine = /*#__PURE__*/function (_Component) {
  _inherits(IconClearTextFormattingLine, _Component);

  var _super = _createSuper(IconClearTextFormattingLine);

  function IconClearTextFormattingLine() {
    _classCallCheck(this, IconClearTextFormattingLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconClearTextFormattingLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconClearTextFormatting",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconClearTextFormattingLine.displayName = "IconClearTextFormattingLine";
  return IconClearTextFormattingLine;
}(Component);

IconClearTextFormattingLine.glyphName = 'clear-text-formatting';
IconClearTextFormattingLine.variant = 'Line';
IconClearTextFormattingLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconClearTextFormattingLine;
export { IconClearTextFormattingLine };